export default __webpack_public_path__ + "static/media/img-09.98439a44.jpg";